export default {
  name: 'TagListSelector',
  mixins: [],
  components: {},
  props: {
    displayProp: {
      type: String,
      default: 'name'
    },
    displayPropExtra: {
      type: String,
      required: false
    },
    searchPlaceholder: {
      type: String,
      required: false
    },
    selectPlaceholder: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    selected: {
      type: Array,
      required: true
    },
    meta: {
      type: Object,
      required: true,
      default: () => ({ loading: false, count: 0 })
    },
    footnote: {
      type: String,
      required: false
    },
    showSelectAll: {
      type: Boolean,
      default: false
    },
    selectAllId: {
      type: String,
      default: 'all'
    },
    selectAllLabel: {
      type: String,
      default: 'Todos los POIs'
    },
    boxSelectionEnabled: {
      type: Boolean,
      default: false
    },
    useBoxSelector: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: {
    allSelected () {
      return this.selected.length === 1 && this.selected[0].id === 'all'
    }
  },
  methods: {
    itemIsSelected (opt) {
      return this.selected.some(d => d.id === opt.id)
    },
    onItemSelected (item) {
      let newZones
      if (this.itemIsSelected(item)) {
        newZones = this.selected.filter(d => d.id !== item.id)
      } else {
        if (item.id === 'all') {
          newZones = [item]
        } else {
          newZones = this.selected.filter(z => z.id !== 'all').concat(item)
        }
      }
      this.emitChange(newZones)
    },
    emitChange (items) {
      this.$emit('selected', items)
    },
    clearAll () {
      this.emitChange([])
    },
    selectAll () {
      this.onItemSelected({
        id: this.selectAllId,
        [this.displayProp]: this.selectAllLabel
      })
    }
  }
}
